export default {
  bgColor: '#FFFFFF',
  bgSecondary: '#F7F7F7',
  bgDark: '#00311E',

  primary: {
    light: '#006B4A',
    main: '#004632',
    dark: '#00311E',
  },

  secondary: {
    light: '#FBB44A',
    main: '#FAA01E',
    dark: '#E08D00',
  },

  accent: {
    light: '#FDD9E0',
    main: '#FAC8D2',
    dark: '#F5AEBB',
  },

  info: {
    light: '#D0F0F8',
    main: '#B4E6F0',
    dark: '#8DD6E6',
  },

  auxiliar: {
    success: '#5FBD74',
    warning: '#FFC107',
    danger: '#DC3545',
  },

  text: {
    dark: {
      little: '#999999',
      medium: '#666666',
      very: '#333333',
    },
    light: {
      little: '#AAAAAA',
      medium: '#CCCCCC',
      very: '#FFFFFF',
    },
  },

  border: '#E8E8E8',
  shadow: 'rgba(0, 0, 0, 0.08)',
};
